import { IStaffRole } from 'interfaces';
import { BaseService } from './BaseService';

class StaffRoleService extends BaseService<IStaffRole> {
  constructor() {
    super('staff-management/staff-roles');
  }
  canDelete = true;
}

export const staffRoleService = new StaffRoleService();
